/** @format */
import imagesLoaded from "imagesloaded";

export default class ScrollToEl {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new ScrollToEl();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on("click", ".js-scroll-to-element", function (e) {
			e.preventDefault();

			$("html, body").animate(
				{
					scrollTop: $($(this).attr("href")).offset().top - 400,
				},
				400
			);
		});

		$(document).on("click", ".js-nav-click-scroll-to-element", function (e) {
			e.preventDefault();

			self.scrollToElOnNavClick($(this));
		});
	}

	scrollToElOnNavClick($link) {
		const self = this;

		let $images = $(); // Initialize an empty jQuery object to aggregate images

		const $anchorSection = $($link.attr("href")).parents(".content-wrapper");
		const $anchorSectionId = $anchorSection.data("id"); // e.g., 5

		// console.log($anchorSection, $anchorSectionId);

		// Get each .content-wrapper section up to the $anchorSection
		const $sections = $("main").find(".content-wrapper");

		$sections.each((_, section) => {
			const $section = $(section);
			const sectionId = $section.data("id");

			if (sectionId === $anchorSectionId) {
				return false; // Stop iteration when the target section is reached
			}

			// Accumulate images with data-lazy-img into the $images collection
			$images = $images.add($section.find("[data-lazy-img]"));
		});

		// console.log($images);

		const headerHeight = self.getHeaderHeight();

		// Only preload images if there are any left with the `data-lazy-img` attribute
		if ($images.length > 0) {
				oc.progressBar.show();

				self.preloadImages($images);

				imagesLoaded($images, () => {
					self.scrollToTarget($link, headerHeight);
					oc.progressBar.hide();
			});
		} else {
			self.scrollToTarget($link, headerHeight);
		}
	}

	getHeaderHeight() {
		const self = this;

		const $headerMain = $(".header-main");
		const $headerSubNav = $(".header-sub-nav.mod-sticky");

		// Initialize the header height with the main header's height
		let headerHeight = $headerMain.outerHeight();

		// Add the sub-nav height only if it exists and the screen width is greater than 1200px
		if ($headerSubNav.length > 0 && window.innerWidth > 1200) {
			headerHeight += $headerSubNav.outerHeight();
		}

		return headerHeight;
	}

	preloadImages($images) {
		$images.each((_, img) => {
			const $img = $(img);
			const src = $img.attr("data-lazy-img");

			if (src) {
				$img.attr("src", src).removeAttr("data-lazy-img");
			}
		});
	}

	scrollToTarget($link, headerHeight) {
		const $target = $($link.attr("href"));

		// console.log(headerHeight);

		// Check if the target exists
		if ($target.length === 0) {
			console.warn("Target element does not exist:", $link.attr("href"));
			return;
		}

		const scrollPos = $target.offset().top - headerHeight;

		$("html, body").animate(
			{
				scrollTop: scrollPos,
			},
			400
		);
	}
}
